module.exports = __webpack_public_path__ + "img/sec_addr.cd2ef08f.svg";